(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["l4g-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('l4g-store')) {
  customElements.define('l4g-store', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.controller = new AbortController();
      this.strings = JSON.parse(this.querySelector('[data-l4g-strings]').textContent);
      this.productDialog = this.querySelector('[data-product-dialog]');
      this.cartDialog = this.querySelector('[data-cart-dialog]');
      this.guideDialog = this.querySelector('[data-guide-dialog]');
      this.cache = new Map();
      this.requestNumber = 0;
      const options = { signal: this.controller.signal };
      this.addEventListener('click', event => this.onClick(event), options);
      this.addEventListener('change', event => this.onChange(event), options);
      this.addEventListener('submit', event => this.onSubmit(event), options);
      this.querySelectorAll('dialog').forEach(dialog => {
        dialog.addEventListener('close', () => {
          if (!this.querySelector('dialog[open]')) document.documentElement.classList.remove('l4g-modal-open');
        }, options);
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        }, options);
      });
      window.addEventListener('pageshow', () => this.refreshCount(), options);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.initialized = false;
      document.documentElement.classList.remove('l4g-modal-open');
    }
    escape(value) {
      return String(value ?? '').replace(/[&<>"']/g, char => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' })[char]);
    }
    money(cents, currency) {
      return new Intl.NumberFormat('es-ES', { style:'currency', currency:currency || this.dataset.currency || 'EUR' }).format(cents / 100);
    }
    async json(url, options = {}) {
      const response = await fetch(url, { credentials:'same-origin', ...options, headers:{ Accept:'application/json', ...options.headers } });
      const data = await response.json();
      if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : this.strings.error);
      return data;
    }
    open(dialog) {
      if (!dialog.open) dialog.showModal();
      document.documentElement.classList.add('l4g-modal-open');
    }
    onClick(event) {
      const target = event.target.closest('button');
      if (!target) return;
      if (target.hasAttribute('data-close')) target.closest('dialog').close();
      if (target.hasAttribute('data-product-url')) this.openProduct(target.dataset.productUrl, target.dataset.productTitle);
      if (target.hasAttribute('data-open-cart')) this.openCart();
      if (target.hasAttribute('data-open-guide')) this.open(this.guideDialog);
      if (target.hasAttribute('data-open-policy')) this.open(this.querySelector('#' + target.dataset.openPolicy));
      if (target.hasAttribute('data-retry-product')) this.openProduct(this.lastProduct.url, this.lastProduct.title);
      if (target.hasAttribute('data-retry-cart')) this.openCart();
      if (target.hasAttribute('data-remove-line')) this.changeCart(target.dataset.removeLine, 0);
    }
    async openProduct(url, title) {
      this.lastProduct = { url, title };
      const content = this.querySelector('[data-product-content]');
      const requestNumber = ++this.requestNumber;
      content.innerHTML = `<div class="l4g-loading"><h2 id="L4GProductTitle">${this.escape(title)}</h2><p role="status">${this.escape(this.strings.loading)}</p></div>`;
      this.open(this.productDialog);
      try {
        let html = this.cache.get(url);
        if (!html) {
          const endpoint = new URL(url, location.origin);
          endpoint.searchParams.set('section_id', 'l4g-product');
          const response = await fetch(endpoint, { credentials:'same-origin' });
          if (!response.ok) throw new Error(this.strings.error);
          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          const product = page.querySelector('[data-l4g-product]');
          if (!product) throw new Error(this.strings.error);
          html = product.outerHTML;
          this.cache.set(url, html);
        }
        if (requestNumber !== this.requestNumber) return;
        content.innerHTML = html;
        content.querySelector('#L4GProductTitle').textContent = title;
        this.variants = JSON.parse(content.querySelector('[data-product-variants]').textContent);
        this.updateVariant();
      } catch (error) {
        if (requestNumber !== this.requestNumber) return;
        content.innerHTML = `<div class="l4g-loading"><h2 id="L4GProductTitle">${this.escape(title)}</h2><p role="alert">${this.escape(this.strings.error)}</p><button class="l4g-button" data-retry-product>${this.escape(this.strings.retry)}</button></div>`;
      }
    }
    updateVariant() {
      const form = this.querySelector('.l4g-product-form');
      if (!form) return;
      const values = Array.from(form.querySelectorAll('[data-product-option]'), select => select.value);
      const variant = values.length ? this.variants.find(item => item.options.every((value, index) => value === values[index])) : this.variants[0];
      const button = form.querySelector('[type="submit"]');
      const price = this.querySelector('[data-variant-price]');
      form.elements.id.value = variant?.id || '';
      button.disabled = !variant?.available;
      form.querySelector('[data-add-label]').textContent = variant ? (variant.available ? this.strings.add : this.strings.sold_out) : this.strings.unavailable;
      price.textContent = variant ? variant.price : this.strings.unavailable;
    }
    onChange(event) {
      if (event.target.matches('[data-product-option]')) this.updateVariant();
      if (event.target.matches('[data-line-quantity]')) {
        const input = event.target;
        if (!input.checkValidity() || !Number.isInteger(Number(input.value))) {
          input.reportValidity();
          return;
        }
        this.changeCart(input.dataset.lineQuantity, Number(input.value));
      }
    }
    async onSubmit(event) {
      if (!event.target.matches('.l4g-product-form')) return;
      event.preventDefault();
      const form = event.target;
      if (this.adding || !form.reportValidity() || !form.elements.id.value) return;
      this.adding = true;
      const errorBox = form.querySelector('[data-product-error]');
      const submit = form.querySelector('[type="submit"]');
      errorBox.hidden = true;
      submit.disabled = true;
      form.querySelector('[data-add-label]').textContent = this.strings.adding;
      try {
        await this.json(this.dataset.addUrl + '.js', { method:'POST', body:new FormData(form) });
        this.querySelector('[data-status]').textContent = this.strings.added;
        this.productDialog.close();
        await this.openCart(true);
      } catch (error) {
        errorBox.textContent = error.message || this.strings.error;
        errorBox.hidden = false;
      } finally {
        this.adding = false;
        this.updateVariant();
      }
    }
    async refreshCount() {
      try {
        const cart = await this.json(this.dataset.cartUrl + '.js');
        this.updateCount(cart.item_count);
      } catch (_) {}
    }
    updateCount(count) {
      this.querySelectorAll('[data-cart-count]').forEach(element => { element.textContent = count; });
    }
    async openCart(added = false) {
      const content = this.querySelector('[data-cart-content]');
      content.innerHTML = `<p class="l4g-loading" role="status">${this.escape(this.strings.loading)}</p>`;
      this.open(this.cartDialog);
      try {
        const cart = await this.json(this.dataset.cartUrl + '.js');
        this.renderCart(cart);
      } catch (error) {
        content.innerHTML = `<div class="l4g-loading"><p role="alert">${this.escape(added ? this.strings.added_recovery : this.strings.error)}</p><button class="l4g-button" data-retry-cart>${this.escape(this.strings.retry)}</button></div>`;
      }
    }
    variantLabel(value) {
      return String(value || '').split(' / ').map(part => this.strings.variant_labels[part] || part).join(' / ');
    }
    renderCart(cart) {
      const e = value => this.escape(value);
      this.updateCount(cart.item_count);
      const content = this.querySelector('[data-cart-content]');
      if (!cart.item_count) {
        content.innerHTML = `<div class="l4g-loading"><p>${e(this.strings.empty)}</p><button class="l4g-button" data-close>${e(this.strings.continue)}</button></div>`;
        return;
      }
      const items = cart.items.map(item => {
        const properties = Object.entries(item.properties || {}).filter(([key,value]) => !key.startsWith('_') && value !== null && value !== '');
        const title = item.product_title.split(' – ')[0].replace(/^.*Leotard\s+/, '');
        return `<article class="l4g-cart-item">${item.image ? `<img src="${e(item.image)}" width="90" height="112" alt="${e(title)}">` : '<div></div>'}<div><h3>${e(title)}</h3><p class="l4g-small">${e(this.variantLabel(item.variant_title))}</p><dl class="l4g-cart-properties">${properties.map(([key,value]) => `<dt>${e(key)}</dt><dd>${e(value)}</dd>`).join('')}</dl><p>${e(this.money(item.final_line_price,cart.currency))}</p><div class="l4g-cart-controls"><label class="l4g-field"><span>${e(this.strings.quantity)}</span><input type="number" inputmode="numeric" min="1" step="1" value="${item.quantity}" data-line-quantity="${e(item.key)}" aria-label="${e(this.strings.quantity)} · ${e(title)}"></label><button class="l4g-text-button" data-remove-line="${e(item.key)}">${e(this.strings.remove)}</button></div></div></article>`;
      }).join('');
      content.innerHTML = `${items}<p class="l4g-error" data-cart-error role="alert" hidden></p><form action="${e(this.dataset.cartUrl)}" method="post" class="l4g-cart-summary"><div class="l4g-cart-subtotal"><span>${e(this.strings.subtotal)}</span><span>${e(this.money(cart.total_price,cart.currency))}</span></div><p class="l4g-small">${e(this.strings.checkout_note)}</p><button class="l4g-button l4g-button--accent l4g-button--wide" name="checkout" type="submit">${e(this.strings.checkout)}</button><button class="l4g-text-button" type="button" data-close>${e(this.strings.continue)}</button></form>`;
    }
    async changeCart(key, quantity) {
      if (this.changingCart) return;
      this.changingCart = true;
      const content = this.querySelector('[data-cart-content]');
      content.setAttribute('aria-busy','true');
      content.querySelectorAll('button,input').forEach(element => { element.disabled = true; });
      try {
        const cart = await this.json(this.dataset.changeUrl + '.js', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({id:key,quantity}) });
        this.renderCart(cart);
      } catch (error) {
        const errorBox = content.querySelector('[data-cart-error]');
        errorBox.textContent = error.message || this.strings.error;
        errorBox.hidden = false;
      } finally {
        this.changingCart = false;
        content.removeAttribute('aria-busy');
        content.querySelectorAll('button,input').forEach(element => { element.disabled = false; });
      }
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
